import { X509CertificateAuthenticationMethodConfiguration } from '@microsoft/microsoft-graph-types-beta';
import { AuthenticationMethodsCertificateBasedSchema } from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/authentication-method-policy/certificate-based/model';
import { updateAuthenticationMethodPolicyConfig } from 'projects/angular-clarity/src/app/stores/client/graph/authentication-methods-policies/actions';

export function remediate(
    _tenant: string,
    policy: X509CertificateAuthenticationMethodConfiguration,
    schema: AuthenticationMethodsCertificateBasedSchema,
) {
    // If state is disabled, only update the state property
    if (schema.properties.state.const === 'disabled') {
        const updatedPolicy: X509CertificateAuthenticationMethodConfiguration = {
            ...policy,
            state: schema.properties.state.const,
        };

        return updateAuthenticationMethodPolicyConfig({
            _tenant,
            policy: updatedPolicy,
        });
    }

    const updatedPolicy: X509CertificateAuthenticationMethodConfiguration = {
        ...policy,
        state: schema.properties.state.const,
    };

    if (schema.properties.includeTargets?.maxItems > 0) {
        updatedPolicy.includeTargets = schema.properties.includeTargets.items.oneOf.map((target) => {
            return {
                id: target.properties.id.const,
                targetType: target.properties.targetType.const,
            };
        });
    } else {
        updatedPolicy.includeTargets = [];
    }

    if (schema.properties.excludeTargets?.maxItems > 0) {
        updatedPolicy.excludeTargets = schema.properties.excludeTargets.items.oneOf.map((target) => {
            return {
                id: target.properties.id.const,
                targetType: target.properties.targetType.const,
            };
        });
    } else {
        updatedPolicy.excludeTargets = [];
    }

    if (schema.properties?.authenticationModeConfiguration) {
        (updatedPolicy as any).authenticationModeConfiguration = {
            ...policy.authenticationModeConfiguration,
            x509CertificateAuthenticationDefaultMode:
                schema.properties.authenticationModeConfiguration.properties.x509CertificateAuthenticationDefaultMode
                    .const,
        };
        if (schema.properties.authenticationModeConfiguration.properties.x509CertificateDefaultRequiredAffinityLevel) {
            (updatedPolicy as any).authenticationModeConfiguration.x509CertificateDefaultRequiredAffinityLevel =
                schema.properties.authenticationModeConfiguration.properties.x509CertificateDefaultRequiredAffinityLevel.const;
        }
    }

    if (schema.properties?.certificateUserBindings?.items) {
        const bindingItems = Array.isArray(schema.properties.certificateUserBindings.items)
            ? schema.properties.certificateUserBindings.items
            : [schema.properties.certificateUserBindings.items];
        (updatedPolicy as any).certificateUserBindings = bindingItems.map((binding: any) => ({
            x509CertificateField: binding.properties.x509CertificateField.const,
            userProperty: binding.properties.userProperty.const,
            priority: binding.properties.priority.const,
            ...(binding.properties.trustAffinityLevel?.const !== undefined && {
                trustAffinityLevel: binding.properties.trustAffinityLevel.const,
            }),
        }));
    }

    if (schema.properties?.crlValidationConfiguration) {
        (updatedPolicy as any).crlValidationConfiguration = {
            state: schema.properties.crlValidationConfiguration.properties.state.const,

            // Even when CRL validation is enabled, Graph expects the property exemptedCertificateAuthoritiesSubjectKeyIdentifiers to be present and not null.
            exemptedCertificateAuthoritiesSubjectKeyIdentifiers: [],
        };
    }

    if (schema.properties?.issuerHintsConfiguration) {
        (updatedPolicy as any).issuerHintsConfiguration = {
            state: schema.properties.issuerHintsConfiguration.properties.state.const,
        };
    }

    return updateAuthenticationMethodPolicyConfig({
        _tenant,
        policy: updatedPolicy,
    });
}
